export const DOMAIN = process.env.NEXT_PUBLIC_MONOCLE_DOMAIN || undefined;
export const SECRET_KEY = process.env.MONOCLE_SECRET_KEY || '';
